function ref(row: any, key: string) {
    key.split('.').forEach(k => (row ? (row = row[k]) : undefined))
    return row
}

export const normalize = (arrayToNormalize: any[], key: string) => {
    return arrayToNormalize.reduce((collector, item) => {
        const returnable = collector
        const refKey = ref(item, key)

        if (!refKey) {
            // throw new Error('Array normalization failure, reference key does not exist')
            // skipping
            return returnable
        }

        if (!returnable[refKey]) {
            returnable[refKey] = []
        }

        returnable[refKey].push({ ...item })

        return returnable
    }, {})
}
